/** Publieke (bezoekers)pagina's die de Apple-huisstijl (.pub) krijgen. Dashboards staan hier bewust niet in. */
const EXACT = new Set([
  "/", "/zorgsoorten", "/zoek-zorgverlener", "/zorgverleners", "/voor-zorgverleners", "/voor-clienten", "/hoe-werkt-het",
  "/abonnementen", "/abonnementen-bedrijven", "/abonnementen-clienten", "/abonnementen-zorgverleners", "/prijzen",
  "/pgb-zorgverleners-vinden", "/pgb-aanvragen", "/contact", "/nieuws", "/vacatures", "/interim-vacatures", "/gemeente-samenwerking",
  "/plaats-advertentie", "/gratis-hulpvraag-plaatsen", "/login", "/auth", "/auth/bedrijf", "/registreer", "/kies-accounttype",
  "/b2b-registratie", "/voorwaarden", "/privacy", "/disclaimer", "/veiligheid", "/over-ons", "/team", "/aanbevelingen",
  "/affiliate", "/affiliate-voorwaarden", "/bedrijven", "/zorgbedrijven", "/zorgbedrijven-overzicht", "/zorgbureaus",
  "/samenwerkingen", "/community", "/community/visitekaartjes", "/visitekaartjes", "/zorg-factuur", "/nodig-uit",
  "/nederland", "/belgie", "/duitsland", "/nieuw-jaar-zorg", "/zo-zien-zorgvragers-je",
]);
const PREFIXES = [
  "/zorgsoorten/", "/nieuws/", "/zorgverlener/", "/abonnementen/", "/bedrijven/", "/aanbeveling/", "/hulpvraag/",
  "/page/", "/nederland/", "/belgie/", "/duitsland/",
];

export function isPublicPath(pathname: string): boolean {
  const p = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return EXACT.has(p) || PREFIXES.some((x) => p.startsWith(x));
}
